// Lib
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

// Utils
import boardSearchPopupStayActivePredicate from './boardSearchPopupStayActivePredicate';
import { selectBoardSearchMigrationComplete } from './state/boardSearchPopupSelector';

// Components
import Icon from '../../../../components/icons/Icon';
import TooltipSource from '../../../../components/tooltips/TooltipSource';
import PopupPanel from '../../../../components/popupPanel/PopupPanel';
import PopupTrigger from '../../../../components/popupPanel/PopupTrigger';
import LoadableBoardSearchPanel from './LoadableBoardSearchPanel';
import LoadableBoardSearchMigrationPanel from './LoadableBoardSearchMigrationPanel';

// Hooks
import useBoardSearchState from './state/useBoardSearchState';
import useBoardSearchMigrationStatusObserver from './useBoardSearchMigrationStatusObserver';

// Constants
import { PopupIds, PopupSections } from '../../../../components/popupPanel/popupConstants';

// Types
import { ImMNCurrentUser } from '../../../../user/currentUserSelector';

// Styles
import '../HeaderUtil.scss';

const SearchUtil = ({
    tooltipEnabled,
}: {
    currentBoardId: string;
    currentUser: ImMNCurrentUser;
    tooltipEnabled: boolean;
}): React.ReactElement => {
    const searchState = useBoardSearchState();

    const isBoardSearchMigrationComplete = useSelector(selectBoardSearchMigrationComplete);
    useBoardSearchMigrationStatusObserver(isBoardSearchMigrationComplete);

    useEffect(() => {
        LoadableBoardSearchPanel.preload();
    }, []);

    return (
        <div className="HeaderUtil BoardSearchUtil">
            <TooltipSource
                tooltipText="Search"
                shortcut={['command', 'f']}
                distance={0}
                enabled={tooltipEnabled}
                delay={700}
                triggerOnMouseEnter
            >
                <PopupTrigger
                    popupId={PopupIds.SEARCH}
                    className="button-search header-util-button"
                    closeSection={PopupSections.HEADER}
                    stayActivePredicate={boardSearchPopupStayActivePredicate}
                >
                    {() => (
                        <div className="header-util-button-content">
                            <Icon name="nav-search" />
                        </div>
                    )}
                </PopupTrigger>
            </TooltipSource>
            <PopupPanel
                popupId={PopupIds.SEARCH}
                ignoredClicksSelector=".CustomSelectInput, .select-option"
                className="BoardSearchPopup"
            >
                {isBoardSearchMigrationComplete ? (
                    <LoadableBoardSearchPanel searchState={searchState} />
                ) : (
                    <LoadableBoardSearchMigrationPanel />
                )}
            </PopupPanel>
        </div>
    );
};

export default SearchUtil;
